import { VERIFY_EMAIL_STATE } from './constants'

export const getStatus = hash => state => state[VERIFY_EMAIL_STATE]?.bookings[hash]?.status
export const getErrorCode = hash => state => state[VERIFY_EMAIL_STATE]?.bookings[hash]?.errorCode
export const getIsFetching = hash => state =>
  state[VERIFY_EMAIL_STATE]?.bookings[hash]?.isFetching || null
